export const authUiEn = {
  home: "Home",
  language: "Language",
  champion: "Champion Play. As One.",
  bulletTeam: "Build your squad in one place",
  bulletTrack: "Track training, fees and welfare",
  bulletWin: "Run matchday together",
  email: "Email",
  password: "Password",
  fullName: "Full name",
  signInTitle: "Welcome back",
  signInSubtitle: "Sign in to manage your club, training and matches.",
  signIn: "Sign in",
  signingIn: "Signing in…",
  or: "or",
  google: "Continue with Google",
  newTo: "New to FanJago?",
  createAccount: "Create an account",
  forgot: "Forgot password?",
  invalidEmail: "Enter a valid email address.",
  passwordRequired: "Password is required.",
  incorrect: "Email or password is incorrect.",
  confirmEmail: "Confirm your email first.",
  resendEmail: "Resend email",
  resendIn: "Resend in {{time}}",
  rate: "Too many attempts. Try again in {{seconds}} s.",
  offline: "You're offline. Check your connection.",
  childManaged: "This account is managed by a parent or club. Ask them to reset your password.",
  captchaRequired: "Complete the verification above, then try again.",
  captchaFailed: "Verification failed. Please try again.",
  forgotTitle: "Reset your password",
  forgotBody: "Enter the email you sign in with. We'll send a link.",
  sendReset: "Send reset link",
  sending: "Sending…",
  backToSignIn: "Back to sign in",
  inboxTitle: "Check your inbox",
  inboxBody: "If an account exists for {{email}}, a reset link is on its way. Open it on this device.",
  differentEmail: "Use a different email",
  spamTip: "Can't find it? Check Spam or Promotions.",
  childReset: "This account is managed by a parent or club. Ask them to set a new password from Children.",
  parentReset: "If this parent email can receive mail, a reset link is on its way. A generated @fanjago.com address cannot receive mail until it is changed.",
  checkingLink: "Checking your reset link…",
  linkExpired: "This link has expired",
  linkExpiredBody: "Reset links work once and expire after 1 hour.",
  sendNewLink: "Send a new link",
  choosePassword: "Choose a new password",
  forEmail: "for {{email}}",
  updatePassword: "Update password",
  updating: "Updating…",
  passwordUpdated: "Password updated",
  passwordUpdatedBody: "You're signed in on this device.",
  goDashboard: "Go to dashboard",
  signInInstead: "Sign in",
  redirectIn: "Continuing in {{seconds}} s.",
  cancelRedirect: "Cancel",
  weak: "Weak",
  fair: "Fair",
  good: "Good",
  strong: "Strong",
  strength: "Password strength",
  showPassword: "Show password",
  hidePassword: "Hide password",
  ruleLength: "At least 8 characters",
  ruleIdentity: "Not your email or name",
  ruleCommon: "Not a common password",
  tooLong: "Use 72 characters or fewer.",
  pendingTitle: "Application status",
  pendingReview: "Your role request is waiting for review.",
  pendingHistory: "Your role request history.",
  pendingEmpty: "No role requests yet.",
  pendingNotify: "You'll get an email when this request is reviewed.",
  pendingApproved: "This request was approved.",
  pendingRejected: "This request was not approved.",
  requestedOn: "Requested on {{date}}",
  yourNote: "Your note",
  goDashboardBtn: "Go to dashboard",
  requestRole: "Request a role",
  registerTitle: "Choose how you'll use FanJago",
  registerSubtitle: "You can add more roles later.",
  stepOf: "{{current}} / {{total}} · {{name}}",
  continue: "Continue",
  back: "Back",
  close: "Close",
  signInLink: "Sign in",
  groupPlay: "Play and follow",
  groupCoach: "Coach",
  groupOrg: "Run an organisation",
  groupTalent: "Talent",
  accessIncluded: "Included with your account",
  accessReview: "Needs review",
  staffNote: "Joining a club as staff (admin, manager, finance)? Ask your club to invite your email.",
  laterNote: "Referee or medical staff? Create an account first, then request the role from your profile.",
  accountTitle: "Create your account",
  detailsTitle: "Role details",
  documentsTitle: "Verification documents",
  documentsBody: "Optional. Adding an ID or certificate can help a reviewer. PDF, JPG or PNG, up to 5 MB.",
  reviewTitle: "Review and create your account",
  edit: "Edit",
  terms: "I agree to the Terms and Privacy Policy.",
  termsLink: "Terms",
  privacyLink: "Privacy Policy",
  termsRequired: "Agree to the Terms and Privacy Policy to continue.",
  accessReviewSla: "Needs review",
  statusPending: "Pending",
  statusApproved: "Approved",
  statusRejected: "Rejected",
  marketing: "Send me product updates. Optional.",
  create: "Create account",
  creating: "Creating account…",
  role: "Role",
  name: "Name",
  accountStep: "Account",
  detailsStep: "Details",
  documentsStep: "Verification",
  reviewStep: "Review",
  roleStep: "Role",
  signupInbox: "We sent a confirmation link to {{email}}. Open it on this device before you sign in.",
  signupReviewLater: "After you confirm and sign in, your {{role}} request is submitted for review. No review time is promised yet.",
  signupRequestSaved: "Your {{role}} request was submitted and needs review. Confirm your email to continue.",
  changeEmail: "Change email",
  openGmail: "Open Gmail",
  errorSummary: "Fix the following before you continue.",
  dobLabel: "Date of birth",
  guardianEmail: "Parent or guardian email",
  under18: "You'll need a parent or guardian to confirm.",
  roles: {
    fan: "Fan",
    fanValue: "Follow clubs, matches and players",
    player: "Player",
    playerValue: "Your passport, training and fees",
    parent: "Parent / guardian",
    parentValue: "Manage your children's training and fees",
    coach: "Coach",
    coachValue: "Run sessions, attendance and welfare",
    club_owner: "Club / academy owner",
    club_ownerValue: "Run your club, teams and staff",
    venue_owner: "Venue owner",
    venue_ownerValue: "List pitches and take bookings",
    tournament_organizer: "Tournament organiser",
    tournament_organizerValue: "Organise competitions and fixtures",
    scout: "Scout",
    scoutValue: "Watch players and share reports",
  },
};

export const authUiMs = {
  home: "Laman utama",
  language: "Bahasa",
  champion: "Permainan juara. Bersatu.",
  bulletTeam: "Bina skuad anda di satu tempat",
  bulletTrack: "Jejak latihan, yuran dan kebajikan",
  bulletWin: "Urus hari perlawanan bersama",
  email: "E-mel",
  password: "Kata laluan",
  fullName: "Nama penuh",
  signInTitle: "Selamat kembali",
  signInSubtitle: "Log masuk untuk urus kelab, latihan dan perlawanan anda.",
  signIn: "Log masuk",
  signingIn: "Sedang log masuk…",
  or: "atau",
  google: "Teruskan dengan Google",
  newTo: "Baru di FanJago?",
  createAccount: "Cipta akaun",
  forgot: "Lupa kata laluan?",
  invalidEmail: "Masukkan alamat e-mel yang sah.",
  passwordRequired: "Kata laluan diperlukan.",
  incorrect: "E-mel atau kata laluan tidak betul.",
  confirmEmail: "Sahkan e-mel anda dahulu.",
  resendEmail: "Hantar semula e-mel",
  resendIn: "Hantar semula dalam {{time}}",
  rate: "Terlalu banyak percubaan. Cuba lagi dalam {{seconds}} saat.",
  offline: "Anda di luar talian. Semak sambungan anda.",
  childManaged: "Akaun ini diurus oleh ibu bapa atau kelab. Minta mereka tetapkan semula kata laluan anda.",
  captchaRequired: "Selesaikan pengesahan di atas, kemudian cuba lagi.",
  captchaFailed: "Pengesahan gagal. Sila cuba lagi.",
  forgotTitle: "Tetapkan semula kata laluan",
  forgotBody: "Masukkan e-mel yang anda gunakan untuk log masuk. Kami akan hantar pautan.",
  sendReset: "Hantar pautan tetapan semula",
  sending: "Menghantar…",
  backToSignIn: "Kembali ke log masuk",
  inboxTitle: "Semak peti masuk anda",
  inboxBody: "Jika akaun wujud untuk {{email}}, pautan tetapan semula sedang dihantar. Buka pada peranti ini.",
  differentEmail: "Guna e-mel lain",
  spamTip: "Tidak jumpa? Semak Spam atau Promosi.",
  childReset: "Akaun ini diurus oleh ibu bapa atau kelab. Minta mereka tetapkan kata laluan baharu dari halaman Anak.",
  parentReset: "Jika e-mel ibu bapa ini boleh menerima mel, pautan tetapan semula sedang dihantar. Alamat @fanjago.com yang dijana tidak boleh menerima mel sehingga ia ditukar.",
  checkingLink: "Menyemak pautan tetapan semula anda…",
  linkExpired: "Pautan ini telah tamat",
  linkExpiredBody: "Pautan tetapan semula hanya boleh digunakan sekali dan tamat selepas 1 jam.",
  sendNewLink: "Hantar pautan baharu",
  choosePassword: "Pilih kata laluan baharu",
  forEmail: "untuk {{email}}",
  updatePassword: "Kemas kini kata laluan",
  updating: "Mengemas kini…",
  passwordUpdated: "Kata laluan dikemas kini",
  passwordUpdatedBody: "Anda telah log masuk pada peranti ini.",
  goDashboard: "Pergi ke papan pemuka",
  signInInstead: "Log masuk",
  redirectIn: "Meneruskan dalam {{seconds}} saat.",
  cancelRedirect: "Batal",
  weak: "Lemah",
  fair: "Sederhana",
  good: "Baik",
  strong: "Kuat",
  strength: "Kekuatan kata laluan",
  showPassword: "Tunjuk kata laluan",
  hidePassword: "Sembunyi kata laluan",
  ruleLength: "Sekurang-kurangnya 8 aksara",
  ruleIdentity: "Bukan e-mel atau nama anda",
  ruleCommon: "Bukan kata laluan yang biasa",
  tooLong: "Guna 72 aksara atau kurang.",
  pendingTitle: "Status permohonan",
  pendingReview: "Permintaan peranan anda menunggu semakan.",
  pendingHistory: "Sejarah permintaan peranan anda.",
  pendingEmpty: "Belum ada permintaan peranan.",
  pendingNotify: "Anda akan terima e-mel apabila permintaan ini disemak.",
  pendingApproved: "Permintaan ini telah diluluskan.",
  pendingRejected: "Permintaan ini tidak diluluskan.",
  requestedOn: "Diminta pada {{date}}",
  yourNote: "Nota anda",
  goDashboardBtn: "Pergi ke papan pemuka",
  requestRole: "Mohon peranan",
  registerTitle: "Pilih cara anda guna FanJago",
  registerSubtitle: "Anda boleh tambah peranan lain kemudian.",
  stepOf: "{{current}} / {{total}} · {{name}}",
  continue: "Teruskan",
  back: "Kembali",
  close: "Tutup",
  signInLink: "Log masuk",
  groupPlay: "Main dan ikut",
  groupCoach: "Jurulatih",
  groupOrg: "Urus organisasi",
  groupTalent: "Bakat",
  accessIncluded: "Termasuk dengan akaun anda",
  accessReview: "Perlu semakan",
  staffNote: "Sertai kelab sebagai kakitangan (pentadbir, pengurus, kewangan)? Minta kelab anda jemput e-mel anda.",
  laterNote: "Pengadil atau kakitangan perubatan? Cipta akaun dahulu, kemudian mohon peranan dari profil anda.",
  accountTitle: "Cipta akaun anda",
  detailsTitle: "Butiran peranan",
  documentsTitle: "Dokumen pengesahan",
  documentsBody: "Pilihan. ID atau sijil boleh membantu semakan. PDF, JPG atau PNG, sehingga 5 MB.",
  reviewTitle: "Semak dan cipta akaun anda",
  edit: "Sunting",
  terms: "Saya bersetuju dengan Terma dan Dasar Privasi.",
  termsLink: "Terma",
  privacyLink: "Dasar Privasi",
  termsRequired: "Setuju dengan Terma dan Dasar Privasi untuk teruskan.",
  accessReviewSla: "Perlu semakan",
  statusPending: "Menunggu",
  statusApproved: "Diluluskan",
  statusRejected: "Ditolak",
  marketing: "Hantar kemas kini produk kepada saya. Pilihan.",
  create: "Cipta akaun",
  creating: "Mencipta akaun…",
  role: "Peranan",
  name: "Nama",
  accountStep: "Akaun",
  detailsStep: "Butiran",
  documentsStep: "Pengesahan",
  reviewStep: "Semakan",
  roleStep: "Peranan",
  signupInbox: "Kami hantar pautan pengesahan ke {{email}}. Buka pada peranti ini sebelum log masuk.",
  signupReviewLater: "Selepas anda sahkan dan log masuk, permintaan {{role}} dihantar untuk semakan. Tempoh semakan belum dijanjikan.",
  signupRequestSaved: "Permintaan {{role}} anda telah dihantar dan perlu semakan. Sahkan e-mel anda untuk teruskan.",
  changeEmail: "Tukar e-mel",
  openGmail: "Buka Gmail",
  errorSummary: "Betulkan perkara berikut sebelum anda teruskan.",
  dobLabel: "Tarikh lahir",
  guardianEmail: "E-mel ibu bapa atau penjaga",
  under18: "Anda perlukan pengesahan ibu bapa atau penjaga.",
  roles: {
    fan: "Peminat",
    fanValue: "Ikut kelab, perlawanan dan pemain",
    player: "Pemain",
    playerValue: "Pasport, latihan dan yuran anda",
    parent: "Ibu bapa / penjaga",
    parentValue: "Urus latihan dan yuran anak anda",
    coach: "Jurulatih",
    coachValue: "Urus sesi, kehadiran dan kebajikan",
    club_owner: "Pemilik kelab / akademi",
    club_ownerValue: "Urus kelab, pasukan dan kakitangan",
    venue_owner: "Pemilik tempat",
    venue_ownerValue: "Senarai padang dan terima tempahan",
    tournament_organizer: "Penganjur kejohanan",
    tournament_organizerValue: "Anjur pertandingan dan jadual",
    scout: "Pengakap",
    scoutValue: "Pantau pemain dan kongsi laporan",
  },
};
